import { defineStore } from 'pinia';
import { ref } from 'vue';

export class Pagination {
    constructor(list, page, perPage, order, filter) {
        this.page = page;
        this.perPage = perPage;
        this.list = list;
        this.order = order;
        this.filter = filter;
    }
}

export const usePaginationStore = defineStore('pagination', () => {
    const pagination = ref(Array())

    return {
        pagination
    }
})